import { z } from 'zod';

const alertTypeValue = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .optional()
  .nullable();
const gpsRangeValue = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .optional()
  .nullable();

/**
 * Bulk settings modal form schema (一括設定).
 * 同意書切れアラート通知: 未選択可. 日前/ヶ月前は modal edit と同じ（自由入力→validate 時エラー表示）.
 */
export const massagerBulkSettingsFormSchema = z
  .object({
    alertType: alertTypeValue,
    alertDay: z.string().optional().or(z.literal('')),
    alertMonth: z.string().optional().or(z.literal('')),
    gpsRange: gpsRangeValue,
  })
  .refine(
    data => {
      if (data.alertType !== 2) return true;
      const s = data.alertDay ?? '';
      return typeof s === 'string' && s.trim() !== '';
    },
    { message: '日数を入力してください。', path: ['alertDay'] }
  )
  .refine(
    data => {
      if (data.alertType !== 2) return true;
      if (!data.alertDay || data.alertDay.trim() === '') return true;
      const s = data.alertDay.trim();
      return /^-?\d+$/.test(s);
    },
    { message: '日数は整数にしてください。', path: ['alertDay'] }
  )
  .refine(
    data => {
      if (data.alertType !== 2) return true;
      if (!data.alertDay || data.alertDay.trim() === '') return true;
      const s = data.alertDay.trim();
      if (!/^-?\d+$/.test(s)) return true;
      const n = parseInt(s, 10);
      return n >= 1 && n <= 999;
    },
    { message: '日数は1〜999までにしてください。', path: ['alertDay'] }
  )
  .refine(
    data => {
      if (data.alertType !== 3) return true;
      const s = data.alertMonth ?? '';
      return typeof s === 'string' && s.trim() !== '';
    },
    { message: '月数を入力してください。', path: ['alertMonth'] }
  )
  .refine(
    data => {
      if (data.alertType !== 3) return true;
      if (!data.alertMonth || data.alertMonth.trim() === '') return true;
      const s = data.alertMonth.trim();
      return /^-?\d+$/.test(s);
    },
    { message: '月数は整数にしてください。', path: ['alertMonth'] }
  )
  .refine(
    data => {
      if (data.alertType !== 3) return true;
      if (!data.alertMonth || data.alertMonth.trim() === '') return true;
      const s = data.alertMonth.trim();
      if (!/^-?\d+$/.test(s)) return true;
      const n = parseInt(s, 10);
      return n >= 1 && n <= 99;
    },
    { message: '月数は1〜99までにしてください。', path: ['alertMonth'] }
  );

export type MassagerBulkSettingsFormData = z.infer<typeof massagerBulkSettingsFormSchema>;
